import { IconProps } from './icon-props';

export const TableFilterIcon = ({ ...props }: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 3.75C1 3.55109 1.07902 3.36032 1.21967 3.21967C1.36032 3.07902 1.55109 3 1.75 3H14.25C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75C15 3.94891 14.921 4.13968 14.7803 4.28033C14.6397 4.42098 14.4489 4.5 14.25 4.5H1.75C1.55109 4.5 1.36032 4.42098 1.21967 4.28033C1.07902 4.13968 1 3.94891 1 3.75ZM3.5 7.75C3.5 7.55109 3.57902 7.36032 3.71967 7.21967C3.86032 7.07902 4.05109 7 4.25 7H11.75C11.9489 7 12.1397 7.07902 12.2803 7.21967C12.421 7.36032 12.5 7.55109 12.5 7.75C12.5 7.94891 12.421 8.13968 12.2803 8.28033C12.1397 8.42098 11.9489 8.5 11.75 8.5H4.25C4.05109 8.5 3.86032 8.42098 3.71967 8.28033C3.57902 8.13968 3.5 7.94891 3.5 7.75ZM6.75 11C6.55109 11 6.36032 11.079 6.21967 11.2197C6.07902 11.3603 6 11.5511 6 11.75C6 11.9489 6.07902 12.1397 6.21967 12.2803C6.36032 12.421 6.55109 12.5 6.75 12.5H9.25C9.44891 12.5 9.63968 12.421 9.78033 12.2803C9.92098 12.1397 10 11.9489 10 11.75C10 11.5511 9.92098 11.3603 9.78033 11.2197C9.63968 11.079 9.44891 11 9.25 11H6.75Z"
      fill="#8496AF"
    />
  </svg>
);
